import React, { useState, useEffect } from 'react';

interface ImageCarouselProps {
  imageDirectory: string;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ imageDirectory }) => {
  const [images, setImages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // This is a simple way to handle images without a backend
    // You can add more images to this array as needed
    const imageList = [
      'images/daniel1.jpg',
      'images/daniel2.jpg',
      'images/daniel3.jpg',
      'images/daniel4.jpg',
      'images/daniel5.jpg',
      'images/daniel6.jpg',
      'images/daniel7.jpg',
      'images/daniel8.jpg',
      'images/daniel9.jpg',
      'images/daniel10.jpg',
      'images/daniel11.jpg',
      'images/daniel12.jpg',
      'images/daniel13.jpg',
      'images/daniel14.jpg',
      'images/daniel15.jpg',
      'images/daniel16.jpg',
      'images/daniel17.jpg',
      'images/daniel18.jpg',
      'images/daniel19.jpg',
    ];
    setImages(imageList);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (images.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => 
      (prevIndex + 1) % images.length
    );
  };

  if (isLoading) {
    return (
      <div className="w-full h-48 bg-gray-200 animate-pulse rounded-lg"></div>
    );
  }

  return (
    <div className="relative w-full overflow-hidden rounded-lg">
      <div className="relative w-full h-48">
        {images.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-500 ${
              index === currentIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image}
              alt={`Daniel ${index + 1}`}
              className="w-full h-full object-contain"
            />
          </div>
        ))}
      </div>
      
      {/* Navigation Arrows */}
      <div className="flex justify-center items-center gap-8 mt-2">
        <button
          onClick={goToPrevious}
          className="bg-white/80 hover:bg-white text-gray-800 rounded p-1 transition-colors duration-200"
          aria-label="Previous image"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={goToNext}
          className="bg-white/80 hover:bg-white text-gray-800 rounded p-1 transition-colors duration-200"
          aria-label="Next image"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ImageCarousel; 